<template>
  <div class="sim_reader response_table">

    <div v-if="loading" style="height: 100%">
      <h3 style="text-align: center" >
        {{translate('no_data')}}
      </h3>
    </div>

    <table v-else>
      <thead>
        <tr>
          <th scope="col">
            {{ translate('sim_server.simserver_name') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.simreader_name') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.client_name') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.version') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.active_simcard_count') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.simcard_count') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.status') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.ts_update') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.ts_create') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="(sim_reader, index) in sim_readers_list"
            :key="index"
            class="sim_reader_item"
            @click="show_info(sim_reader.id)"
        >
          <td :data-label="translate('sim_server.simserver_name')">
            <span>{{sim_reader.sim_server_name }}</span>
          </td>
          <td :data-label="translate('sim_server.simreader_name')">
            <span>{{sim_reader.name }}</span>
          </td>
          <td :data-label="translate('sim_server.client_name')">
            <span>{{sim_reader.client_name }}</span>
          </td>
          <td :data-label="translate('sim_server.version')">
            <span>{{sim_reader.version }}</span>
          </td>
          <td :data-label="translate('sim_server.active_simcard_count')">
              <span>{{sim_reader.active_simcard_count}}</span>
          </td>
          <td :data-label="translate('sim_server.simcard_count')">
              <span>{{sim_reader.simcard_count}}</span>
          </td>
          <td :data-label="translate('sim_server.status')">
            <span>{{sim_reader.status }}</span>
          </td>
          <td :data-label="translate('sim_server.ts_update')">
            <span>{{ get_date(sim_reader.ts_update) }}</span>
          </td>
          <td :data-label="translate('sim_server.ts_create')">
            <span>{{ get_date(sim_reader.ts_create) }}</span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>


export default {
  name: 'SimReader',
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      loading: true,
      sim_readers_list: {}
    }
  },

  created () {
    this.get_sim_readers_list()
  },

  methods: {
    get_sim_readers_list(){
      this.$http.simcard.getSimReaders((response) => {
        this.sim_readers_list = response.data
        this.loading = false
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .sim_reader{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
